/* eslint-disable max-len */
import searchIcon from "../../assets/images/Search_icon.png";
import clearIcon from "../../assets/images/clear.png";
import searchQuery from "../../assets/images/search_query.png";
import leftArrowActive from "../../assets/images/leftArrowActive.png";
import leftArrowInactive from "../../assets/images/leftArrowInactive.png";
import rightArrowActive from "../../assets/images/rightArrowActive.png";
import rightArrowInactive from "../../assets/images/rightArrowInactive.png";
import CallExperts from "../../assets/images/call_experts.png";
import NoResults from "../../assets/images/no_results_found.png";
import FeedbackSuccessImage from "../../assets/images/feedback_success.png";
import FeedbackFailureImage from "../../assets/images/feedback_failure.png";
import SrdNoImage from "../../assets/images/srd_no_result.png";
import leftArrowNavigateInactive from "../../assets/images/leftNavigateArrowInactive.png";
import rightArrowNavigaetInactive from "../../assets/images/rightArrowNavigateInactive.png";
import leftArrowNavigateactive from "../../assets/images/leftArrowNavigateActive.png";
import rightArrowNavigateactive from "../../assets/images/rightArrowNavigateActive.png";
import feedbackIcon from "../../assets/images/feedbackIcon.png";
import CloseIcon from "../../assets/images/help_close.png";
import WhoWeAre from "../../assets/images/Who_we_are.png";
import PageNotFoundImg from "../../assets/images/404_image.png";
import ErrorLogo from "../../assets/images/Error.png";

export default {
  "autoSuggest": {
    "button_txt": "Search",
    "icon": searchIcon,
    "clearIcon": clearIcon,
    "clearIcon_alt_txt": "clear",
    "Placeholder_txt": "Search by product name",
    "Placeholder_forkeyword_txt": "Enter your question",
    "error_logo": ErrorLogo,
    "error_logo_alt": "error",
    "error_message": "Please enter / select a product first.",
    "error_message_search_term": "A search term must be entered in order to continue"
  },
  "searchAccordian": {
    "expand_txt": "EXPAND SECTION",
    "collapse_txt": "COLLAPSE SECTION",
    "full_document_txt": "VIEW FULL DOCUMENT",
    "form_txt": "FORM",
    "source_txt": "SOURCE",
    "last_updated": "LAST UPDATE:",
    "showFullTitle_txt": "view full title",
    "showLessTitle_txt": "view less"
  },
  "search": {
    "home_txt": "Home",
    "arrow_txt": ">",
    "arrow_alt_txt": "arrow",
    "search_result_txt": "Search Result",
    "srd_no_img": SrdNoImage,
    "srd_no_alt_txt": "Medical Information Result",
    "prescribing_txt": "Prescribing Information",
    "scientific_txt": "Drug Information Responses",
    "result_txt": "Result",
    "zero_txt": "0",
    "max_srd": "5",
    "looking_txt": "Looking for something more specific?",
    "type_txt": "Type a more detailed query to search our full library of drug information responses",
    "call_experts_img": CallExperts,
    "phone_alt_txt": "phone",
    "cant_txt": "Can’t find what you are looking for?",
    "call_txt": "Call our Experts on",
    "number_txt": "(833) 966-1212",
    "search_query_img": searchQuery,
    "search_query_alt_txt": "search product information - logo",
    "looking_for_txt": "Looking for Product Information or a Clinical Search?​",
    "type_a_txt": "Type a query in the above search box to reach our full library of product labels and drug information responses.",
    "zero_result_type_a_txt": "Type a product name and query in the above search or for more information please visit:",
    "zero_result_des": "Please try asking another question in the above search or",
    "connect_member": "connect with below member(s) for medical information inquiries:",
    "feedback_icon": feedbackIcon,
    "close_icon": CloseIcon,
    "tooltipContent": "Please give your feedback",
    "products_txt": "products",
    "more_info_placeholder": "For more information, <br> visit ",
    "non_member_placeholder": "The manufacturer of the product is not a member of phactMI, therefore there are not any Drug Information Responses available.",
    "medical_info_placeholder": "for medical information inquiries related to ",
    "product_placrHolder": "Related to",
    "or_call": "Or Call ",
    "maint_msg_title": "Planned Maintenance Update in Progress",
    "maint_msg_desc": "This service is currently unavailable due to a scheduled maintenance between 2:00-6:00 AM EST. Please check back soon.",
    "under_maint_image": PageNotFoundImg,
    "under_maint_image_Alt": "under maintenance image",
    "dummySearch": {
      searchResults: [
        {
          documentUrl: "/substances/Novo_Novo-SAX+026?query=saxenda+dosing",
          id: "Novo_Novo-SAX 026",
          lastUpdatedDate: "1/31/2020",
          snippet: {
            summary: "<p style=margin-top:0pt; margin-bottom:0pt; widows:0; orphans:0; font-size:10pt><span style=font-family:Verdana; -aw-import:ignore> </span></p><ul style=margin:0pt; padding-left:0pt type=disc><li style=margin-left:9.6pt; margin-bottom:6pt; padding-left:8.4pt; font-family:serif; font-size:10pt; -aw-font-family:'Symbol'; -aw-font-weight:normal; -aw-number-format:''><span style=font-family:Verdana><hi>Saxenda</hi></span><span style=font-family:Verdana; font-size:6.67pt; vertical-align:super>®</span><span style=font-family:Verdana> should be initiated with a <hi>dose</hi> of 0.6 mg per day for one week; after one week, the <hi>dose</hi> should be increased in weekly increments of 0.6 mg to the recommended dosage of 3 mg once daily.</span><span style=font-family:Verdana; font-size:6.67pt; vertical-align:super>1</span><span style=font-family:Verdana; -aw-import:spaces>  </span></li><li style=margin-left:9.6pt; margin-bottom:6pt; padding-left:8.4pt; font-family:serif; font-size:10pt; -aw-font-family:'Symbol'; -aw-font-weight:normal; -aw-number-format:''><span style=font-family:Verdana><hi>Saxenda</hi></span><span style=font-family:Verdana; font-size:6.67pt; vertical-align:super>®</span><span style=font-family:Verdana> can be administered once daily at any time of day, independently of meals, and can be injected subcutaneously in the abdomen, thigh or upper arm; Novo Nordisk has not studied alternative <hi>dosing</hi> regimens.</span><span style=font-family:Verdana; font-size:6.67pt; vertical-align:super>1</span><span style=font-family:Verdana> </span></li><li style=margin-left:9.6pt; margin-bottom:6pt; padding-left:8.4pt; font-family:serif; font-size:10pt; -aw-font-family:'Symbol'; -aw-font-weight:normal; -aw-number-format:''><span style=font-family:Verdana>Discontinue <hi>Saxenda</hi></span><span style=font-family:Verdana; font-size:6.67pt; vertical-align:super>®</span><span style=font-family:Verdana> if the patient has not lost at least 4% of baseline body weight after 16 weeks of treatment as this has been showed to predict a clinically meaningful weight loss of at least 5% by 1 year.</span><span style=font-family:Verdana; font-size:6.67pt; vertical-align:super>1</span><span style=font-family:Verdana> </span></li><li style=margin-left:9.6pt; margin-bottom:6pt; padding-left:8.4pt; font-family:serif; font-size:10pt; -aw-font-family:'Symbol'; -aw-font-weight:normal; -aw-number-format:''><span style=font-family:Verdana>For information on using the <hi>Saxenda</hi></span><span style=font-family:Verdana; font-size:6.67pt; vertical-align:super>®</span><span style=font-family:Verdana> pen, please refer to the Instructions for Use.</span></li></ul><p style=margin-top:0pt; margin-bottom:0pt; widows:0; orphans:0; font-size:10pt><span style=font-family:Verdana; -aw-import:ignore> </span></p>"
          },
          sourceDisplayName: "Novo Nordisk",
          summaryUrl: "/substances/summaries/Novo_Novo-SAX+026?query=saxenda+dosing",
          title: "Saxenda Dosing - Guidelines"
        }
      ],
      totalHits: 1,
      spl: [
        {
          drug: "Saxenda",
          form: "INJECTION, SOLUTION",
          producer: "Novo Nordisk",
          setId: "3946d389-0926-4f77-a708-0acb8153b143",
          fragment: "<div class=\"Warning HighlightsBoxedWarning\">"+
          "<div>"+
             "<h1 class=\"Warning\">WARNING: RISK OF THYROID C-CELL TUMORS</h1>"+
             "<h1 class=\"Warning\"><span class=Italics>See full prescribing information for complete boxed warning.</span></h1>"+
             "<dl>"+
                "<dt>•</dt>"+
                "<dd><span class=\"Bold\">Liraglutide causes thyroid C-cell tumors at clinically relevant exposures in both"+
                      "genders of rats and mice.  It is unknown whether Saxenda causes thyroid C-cell tumors,"+
                      "including medullary thyroid carcinoma (MTC), in humans, as the human relevance of"+
                      "liraglutide-induced rodent thyroid C-cell tumors has not been determined (<a href=#ID_a0710772-4712-4bb6-bc4a-2576bb3d6d12>5.1</a>).</span></dd>"+
                "<dt>•</dt>"+
                "<dd><span class=\"Bold\">Saxenda is contraindicated in patients with a personal or family history of MTC or"+
                      "in patients with Multiple Endocrine Neoplasia syndrome type 2 (MEN 2). Counsel patients"+
                      "regarding the potential risk of MTC and the symptoms of thyroid tumors (<a href=#ID_6d53b742-cae4-43bd-9ddb-1f0ee225f67f>4</a>, <a href=#ID_a0710772-4712-4bb6-bc4a-2576bb3d6d12>5.1</a>, <a href=#ID_3af8aca6-545d-4bac-9924-92c8f786261d>13.1</a>).</span></dd>"+
             "</dl>"+
          "</div>"+
       "</div>",
          fullSection: "<div class=\"Warning HighlightsBoxedWarning\">"+
          "<div>"+
             "<h1 class=\"Warning\">WARNING: RISK OF THYROID C-CELL TUMORS</h1>"+
             "<h1 class=\"Warning\"><span class=Italics>See full prescribing information for complete boxed warning.</span></h1>"+
             "<dl>"+
                "<dt>•</dt>"+
                "<dd><span class=\"Bold\">Liraglutide causes thyroid C-cell tumors at clinically relevant exposures in both"+
                      "genders of rats and mice.  It is unknown whether Saxenda causes thyroid C-cell tumors,"+
                      "including medullary thyroid carcinoma (MTC), in humans, as the human relevance of"+
                      "liraglutide-induced rodent thyroid C-cell tumors has not been determined (<a href=#ID_a0710772-4712-4bb6-bc4a-2576bb3d6d12>5.1</a>).</span></dd>"+
                "<dt>•</dt>"+
                "<dd><span class=\"Bold\">Saxenda is contraindicated in patients with a personal or family history of MTC or"+
                      "in patients with Multiple Endocrine Neoplasia syndrome type 2 (MEN 2). Counsel patients"+
                      "regarding the potential risk of MTC and the symptoms of thyroid tumors (<a href=#ID_6d53b742-cae4-43bd-9ddb-1f0ee225f67f>4</a>, <a href=#ID_a0710772-4712-4bb6-bc4a-2576bb3d6d12>5.1</a>, <a href=#ID_3af8aca6-545d-4bac-9924-92c8f786261d>13.1</a>).</span></dd>"+
             "</dl>"+
          "</div>"+
       "</div>"
        }
      ]
    }
  },
  "noResults": {
    "call_experts_img": CallExperts,
    "phone_alt_txt": "phone",
    "cant_txt": "Can’t find what you are looking for?",
    "call_txt": "Call our Experts on",
    "number_txt": "(833) 966-1212",
    "no_product_txt": "Prescribing Information for product \"${product}\" is not available.",
    "please_ensure_txt": "Type a more detailed query, including product name, to search our full library of Drug Information Responses.",
    "no_results_img": NoResults,
    "no_results_alt_txt": "no results"
  },
  "noPiResults": {
    "no_product_txt": "The PI associated with this product could not be found.",
    "please_ensure_txt": "Please navigate to manufacturer's page to find additional resources for contacting the manufacturer and obtaining product information.",
    "no_results_img": NoResults,
    "no_results_alt_txt": "no results"
  },
  "noSrdResults": {
    "coming_soon_txt": "We are releasing new Drug Information Responses in phases across",
    "note_txt":"Please note that we are releasing our new access to Drug Information Responses in phases across 2020 and 2021.",
    "email_input_heading": "Please provide us your email address so we can notify you as we add more documents and continue to enhance the functionality.",
    "email_heading_non_member": "Please provide your email address if you are interested in receiving communications on phactMI.",
    "email_placeholder": "Email Address",
    "medical_response_title": "Drug Information Responses",
    "no_product_message": "Please enter a product name to search the full library of Drug Information Responses.",
    "mir_limited_txt": "phactMI returns a maximum of (5) Medical Responses per search. There may be other relevant responses matching your search that require more specific search terms to be returned in the top five."
  },
  "for_srd": "srd",
  "of_txt": " of ",
  "paginationItems": {
    "left_arrow_active": leftArrowActive,
    "left_arrow_Inactive": leftArrowInactive,
    "right_arrow_active": rightArrowActive,
    "right_arrow_Inactive": rightArrowInactive,
    "previous_text": "Previous",
    "next_text": "Next"
  },
  "feedback" : {
    "input_field_placeholder": "Let us know why?",
    "submit_button_text": "Submit",
    "informational_text": "Your feedback is very valuable for us!",
    "radio_buttons_array": ["Yes", "No"],
    "question_text": "Did you find this helpful?",
    "success_image": FeedbackSuccessImage,
    "success_image_alt_text": "Submitted Succesfully",
    "success_message": "Your feedback has been sent successfully.",
    "success_headline": "Thank You!",
    "failure_image": FeedbackFailureImage,
    "failure_image_alt_text": "Unable to submit",
    "failure_message": "Your feedback could not be recorded! Please try again later.",
    "failure_headline": "We are sorry",
    "leftArrowNavigateInactive": leftArrowNavigateInactive,
    "rightArrowNavigaetInactive": rightArrowNavigaetInactive,
    "leftArrowNavigateactive": leftArrowNavigateactive,
    "rightArrowNavigateactive": rightArrowNavigateactive,
    "no_txt":"No"
  },
  "piDetailsResources": {
    "search": "Search",
    "separator": ">",
    "download_txt": "Download",
    "formLabel": "FORM",
    "source": "SOURCE",
    "sourceSeparator": "|",
    "registered": "&reg;"
  },
  "srdDocumentDetails": {
    "search": "Search",
    "separator": ">",
    "download_txt": "Download",
    "product": "PRODUCT",
    "source": "SOURCE",
    "sourceSeparator": "|",
    "registered": "&reg;"
  },
  "tabLabels": ["Prescribing Information", "Drug Information Responses"],
  "email_send_type": "SrdDetails",
  "googleAnalytics": {
    accessKey: "UA-163094284-1",
    dimension1_txt: "dimension1",
    dimension2_txt: "dimension2",
    dimension3_txt: "dimension3",
    dimension4_txt: "dimension4",
    dimension5_txt: "dimension5",
    dimension6_txt: "dimension6",
    dimension7_txt: "dimension7",
    piexpandclick_txt: "piexpandsectionclicks",
    pisummarysectionexpandclick: "pisummarysectionexpandclick",
    pisummarysectioncollapseclick: "pisummarysectioncollapseclick",
    pidocumentsectionclicks: "pidocumentsectionclicks",
    srdexpandclick_txt: "srdexpandsectionclicks",
    picollapseclick_txt: "picollapsesectionclicks",
    srdcollapseclick_txt: "srdcollapsesectionclicks",
    piviewfulldoc_txt: "piviewfulldocumentclicks",
    zeroResultContactTracking: "zeroResultContactTracking",
    patientResourceContactTracking: "patientResourceContactTracking",
    zeroResultEmailTracking: "zeroResultEmailTracking",
    patientResourceEmailTracking: "patientResourceEmailTracking",
    zeroResultUrlTracking: "zeroResultUrlTracking",
    patientResourceUrlTracking: "patientResourceUrlTracking",
    srdviewfulldoc_txt: "srdviewfulldocumentclicks",
    search_txt: "search",
    pageview_txt: "pageview",
    externalclicks_txt: "externellinkclicks"
  },
  "mirpopupResource": {
    "ok_text": "Ok",
    "cancel_text": "Cancel",
    "heading": "The content provided in the Drug Information Responses is only related to the products specifically mentioned in the response documents. It does not pertain to each of the Prescribing Information documents returned",
    "description": "Yes, I understand that the documents provided only relate to the products specifically mentioned in those documents"
  },
  "mirConfirmationPopup": {
    "before_yo_go_txt": "Before you go…",
    "description": "You can view Drug Information Responses which are summaries of available scientific data relating to a specific topic and phactMI member products.",
    "continue_txt": "Continue",
    "cancel_txt": "Cancel",
    "popup_image": WhoWeAre
  },
  "no_search_term_txt": "Drug Information Responses are returned only when search term(s) are entered"
  // "doximity": {
  //   "shareMessage": "You have received a Drug Information response from a Doximity colleague, powered by PhactMI. Please copy the below URL and paste it into your browser to see the information being shared with you. \n",
  //   "shareSubject": "Drug Information Document"
  // }
}
